/* Mint-HR-Review · số đo theo board (CW 1240, thẻ r16 padding 16/18). Màu chỉ var(--…). */
.page { display: flex; flex-direction: column; gap: 14px; padding: 2px 0 24px; min-width: 0; font-size: 13px; }
.tabs { display: flex; min-width: 0; }
.warn { color: var(--warn); }
.mute { color: var(--lb); }
.sub { display: block; font-size: 12px; color: var(--lb); }
.tx2 { color: var(--tx2); }
.right { text-align: right; justify-content: flex-end; }
.ctr { text-align: center; }
.bold { font-weight: var(--fw-label); }
.col { display: flex; flex-direction: column; gap: 14px; min-width: 0; }
.row { display: flex; align-items: center; gap: 8px; }

.kpis { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 14px; margin-top: 4px; }
.kpi { padding: 16px 20px; border-radius: 16px; background: var(--card); box-shadow: var(--sh); }
.kpiK { color: var(--lb); }
.kpiV { display: flex; align-items: baseline; gap: 8px; margin-top: 4px; min-width: 0; }
.kpiV b { font-size: 28px; font-weight: var(--fw-label); letter-spacing: -0.03em; white-space: nowrap; }
.kpiV span { font-size: 12px; color: var(--lb); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.card { border-radius: 16px; background: var(--card); box-shadow: var(--sh); padding: 16px 18px; display: flex; flex-direction: column; gap: 14px; }
.cardHd { display: flex; align-items: baseline; gap: 10px; }
.cardHd h2, .objHd h2, .gapHd { margin: 0; font-size: 16px; font-weight: var(--fw-title); }
.cardHd span { font-size: 12px; color: var(--lb); }

.chip { display: inline-flex; padding: 1px 8px; border-radius: 999px; font-size: 11px; font-weight: var(--fw-label); white-space: nowrap; }
.tWarn { background: var(--warn-bg); color: var(--warn); }
.tPri { background: var(--pri-bg); color: var(--link); }
.tOk { background: var(--ok-bg); color: var(--ok); }
.tErr { background: var(--err-bg); color: var(--err); }
.tMute { background: var(--sub); color: var(--tx2); }
.pGrid .chip { font-size: 12px; padding: 2px 9px; }

.pill { height: 28px; padding: 0 10px; border: 0; border-radius: 8px; background: var(--card); color: var(--tx2); box-shadow: inset 0 0 0 1px var(--bd); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.pillBig { height: 30px; border-radius: 9px; }
.pillOn { background: var(--pri-bg); color: var(--link); box-shadow: inset 0 0 0 1px var(--pri-bd); }
.filters { display: flex; flex-wrap: wrap; gap: 6px; }
.act { height: 30px; padding: 0 10px; border: 0; border-radius: 9px; background: var(--pri-bg); color: var(--link); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.sq { width: 28px; height: 28px; border: 0; border-radius: 8px; background: var(--ctl); color: var(--tx2); font: inherit; cursor: pointer; }
.link { margin-left: auto; padding: 0; border: 0; background: none; font: inherit; font-weight: var(--fw-label); color: var(--link); cursor: pointer; text-align: left; }
button:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
@media (hover: hover) { .pill:hover { background: var(--ctl); } .pillOn:hover { background: var(--pri-bd); } .act:hover { background: var(--pri-bd); } .sq:hover { background: var(--bd); } }

.menu { position: absolute; top: 74px; right: 24px; z-index: 30; width: 300px; padding: 6px; border-radius: 14px; background: var(--card); box-shadow: var(--pop); display: flex; flex-direction: column; }
.menu button { display: flex; flex-direction: column; align-items: flex-start; gap: 2px; padding: 9px 12px; border: 0; border-radius: 10px; background: transparent; color: var(--tx); font: inherit; font-weight: var(--fw-label); text-align: left; cursor: pointer; }
.menu button span { font-size: 12px; font-weight: 400; color: var(--lb); }
@media (hover: hover) { .menu button:hover { background: var(--ctl); } }

.cycGrid { display: grid; grid-template-columns: 300px minmax(0, 1fr); gap: 14px; align-items: start; }
.cycGrid > section:first-child { gap: 4px; }
.cycItem { display: flex; flex-direction: column; align-items: stretch; gap: 4px; padding: 10px 12px; border: 1px solid transparent; border-radius: 12px; background: transparent; color: var(--tx); font: inherit; text-align: left; cursor: pointer; }
.cycItem b { flex: 1; min-width: 0; font-weight: var(--fw-label); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.cycOn { background: var(--pri-bg); border-color: var(--pri-bd); }
.bar, .bar5, .bar6 { display: block; border-radius: 3px; background: var(--line); overflow: hidden; }
.bar { height: 4px; }
.bar5 { height: 5px; }
.bar6 { height: 6px; }
.bar > span, .bar5 > span, .bar6 > span { display: block; height: 100%; background: var(--d-blue); }
.bar5 > span.tOk { background: var(--ok); } .bar5 > span.tWarn { background: var(--warn); } .bar5 > span.tErr { background: var(--err); }
.fDone { background: var(--ok) !important; }

.steps { margin: 0; padding: 0; list-style: none; display: flex; gap: 10px; }
.steps li { flex: 1 1 0; min-width: 0; display: flex; flex-direction: column; gap: 6px; }
.steps b { font-weight: var(--fw-label); white-space: nowrap; }
.prog { margin-left: auto; font-size: 12px; color: var(--lb); }
.dot { width: 24px; height: 24px; flex-shrink: 0; border-radius: 50%; background: var(--ctl); color: var(--lb); font-size: 12px; font-weight: var(--fw-title); display: flex; align-items: center; justify-content: center; }
.dotDone { background: var(--ok); color: var(--card); }
.dotCur { background: var(--pri); color: var(--card); }
.remind { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; padding: 10px 12px; border-radius: 12px; background: var(--sub); }
.remind > button:last-child { margin-left: auto; }
.remindK { display: inline-flex; align-items: center; gap: 6px; font-weight: var(--fw-label); }

.filters + .pGrid { margin-top: 8px; }
.pGrid { display: grid; grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr) 110px 110px 70px 92px; column-gap: 10px; align-items: center; }
.th { font-size: 12px; color: var(--lb); font-weight: var(--fw-label); padding: 6px 0; }
.pName { display: flex; align-items: center; gap: 10px; min-width: 0; min-height: 52px; padding: 0; border: 0; border-top: 1px solid var(--line); background: transparent; color: var(--tx); font: inherit; text-align: left; cursor: pointer; }
.pName b { display: block; font-weight: var(--fw-label); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pName > span:last-child { min-width: 0; }
.avatar { width: 32px; height: 32px; flex-shrink: 0; border-radius: 50%; background: var(--pri-bg); color: var(--link); font-size: 12px; font-weight: var(--fw-title); display: flex; align-items: center; justify-content: center; }
.cell { min-height: 52px; display: flex; align-items: center; border-top: 1px solid var(--line); }
.dense .pName, .dense .cell { min-height: 40px; font-size: 12px; }
.noMatch { padding: 24px; text-align: center; color: var(--lb); }

.okBar { display: flex; align-items: center; gap: 10px; }
.objHd { display: flex; align-items: center; gap: 10px; margin-bottom: -8px; }
.objHd h2 { flex: 1; min-width: 0; }
.objPct { width: 44px; text-align: right; font-weight: var(--fw-title); }
.krRow { display: grid; grid-template-columns: minmax(0, 1fr) 90px 150px 110px 168px; gap: 12px; align-items: center; min-height: 48px; border-top: 1px solid var(--line); }
.krK { font-weight: var(--fw-label); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.krV { display: flex; flex-direction: column; gap: 4px; font-size: 12px; color: var(--tx2); }
.krRow > .chip { justify-self: start; font-size: 12px; padding: 2px 9px; }
.krAct { display: flex; align-items: center; gap: 4px; justify-content: flex-end; }

.compGrid { display: grid; grid-template-columns: minmax(0, 1fr) 340px; gap: 14px; align-items: start; }
.compGrid > section { gap: 0; }
.compGrid > section .okBar { margin-bottom: 10px; flex-wrap: wrap; }
.cfGrid { display: grid; grid-template-columns: minmax(0, 1fr) repeat(5, 110px); gap: 6px; align-items: center; }
.cfName { font-weight: var(--fw-label); padding: 10px 0; border-top: 1px solid var(--line); }
.cfCell { height: 38px; border: 0; border-radius: 10px; background: var(--sub); display: flex; align-items: center; justify-content: center; gap: 3px; cursor: pointer; }
.cfCell:disabled { cursor: default; }
.cfDot { width: 8px; height: 8px; border-radius: 50%; background: var(--line); }
.cfOn { background: var(--pri); }
.compGrid > aside { gap: 4px; }
.gapHd { margin-bottom: 4px; }
.gap { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 9px 0; border-top: 1px solid var(--line); }
.gap b { font-weight: var(--fw-label); }
.compGrid > aside .link { margin: 6px 0 0; }

.rv { display: flex; flex-direction: column; gap: 14px; font-size: 13px; }
.rvKpi { display: flex; align-items: center; gap: 10px; padding: 10px 12px; border-radius: 12px; background: var(--sub); color: var(--lb); }
.rvKpi b { margin-left: auto; color: var(--tx); font-weight: var(--fw-title); }
.rvGrid { display: grid; grid-template-columns: minmax(0, 1fr) 54px 200px; gap: 8px; align-items: center; }
.rvRow { min-height: 52px; border-top: 1px solid var(--line); }
.scores { display: flex; gap: 4px; justify-content: center; }
.score { width: 34px; height: 32px; padding: 0; border-radius: 9px; font-size: 13px; }
.rvTot { display: flex; align-items: center; gap: 12px; padding: 12px 14px; border-radius: 12px; background: var(--pri-bg); }
.rvTot > div { flex: 1; }
.grade { display: inline-flex; padding: 4px 12px; border-radius: 999px; font-size: 14px; font-weight: var(--fw-title); }

.nf { display: flex; flex-direction: column; gap: 12px; }
.nfK { font-size: 12px; font-weight: var(--fw-label); color: var(--tx2); margin-bottom: 6px; }
.req { color: var(--err); }
.nfIn { box-sizing: border-box; width: 100%; height: 40px; padding: 0 12px; border-radius: 10px; border: 1px solid var(--bd); background: var(--card); color: var(--tx); font: inherit; }
.nfIn[aria-invalid='true'] { border-color: var(--err); }

@media (max-width: 1100px) {
  .kpis { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .cycGrid, .compGrid { grid-template-columns: minmax(0, 1fr); }
  .pGrid { grid-template-columns: minmax(0, 1fr) 100px 100px 92px; }
  .pGrid > :nth-child(6n+2), .pGrid > :nth-child(6n+5) { display: none; }
}
